import * as React from 'react';

const VoucherRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 192 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_13559_1746)">
            <path
                d="M0 16C0 7.16344 7.16344 0 16 0H176C184.837 0 192 7.16344 192 16V112C192 120.837 184.837 128 176 128H16C7.16344 128 0 120.837 0 112V16Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.37258 4 4 9.37258 4 16V112C4 118.627 9.37258 124 16 124H176C182.627 124 188 118.627 188 112V16C188 9.37258 182.627 4 176 4ZM16 0C7.16344 0 0 7.16344 0 16V112C0 120.837 7.16344 128 16 128H176C184.837 128 192 120.837 192 112V16C192 7.16344 184.837 0 176 0H16Z"
                fill="#E8E8E7"
            />
            <path
                d="M32 34C32 30.6863 34.6863 28 38 28H154C157.314 28 160 30.6863 160 34V94C160 97.3137 157.314 100 154 100H38C34.6863 100 32 97.3137 32 94V34Z"
                fill="#E9F7C3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M96 84C107.046 84 116 75.0457 116 64C116 52.9543 107.046 44 96 44C84.9543 44 76 52.9543 76 64C76 75.0457 84.9543 84 96 84ZM96 81.5C101.244 81.5 105.949 79.1934 109.157 75.5394C106.607 70.8968 101.671 67.75 96.0004 67.75C90.3294 67.75 85.3935 70.897 82.8437 75.5399C86.051 79.1936 90.7562 81.5 96 81.5ZM102.562 58.375C102.562 61.9994 99.6244 64.9375 96 64.9375C92.3756 64.9375 89.4375 61.9994 89.4375 58.375C89.4375 54.7506 92.3756 51.8125 96 51.8125C99.6244 51.8125 102.562 54.7506 102.562 58.375Z"
                fill="#94AF66"
            />
            <path
                d="M51 58.375V55.875C55.375 55.5625 57.1629 53.375 57.875 50.25H62.25V75.25H67.25V77.75H51V75.25H56V58.375H51Z"
                fill="#94AF66"
            />
            <path
                d="M124.75 58.375V55.875C129.125 55.5625 130.913 53.375 131.625 50.25H136V75.25H141V77.75H124.75V75.25H129.75V58.375H124.75Z"
                fill="#94AF66"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 34C32 30.6863 34.6863 28 38 28H154C157.314 28 160 30.6863 160 34V94C160 97.3137 157.314 100 154 100H38C34.6863 100 32 97.3137 32 94V34ZM38 32H154C155.105 32 156 32.8954 156 34V94C156 95.1046 155.105 96 154 96H38C36.8954 96 36 95.1046 36 94V34C36 32.8954 36.8954 32 38 32Z"
                fill="#94AF66"
            />
        </g>
        <defs>
            <clipPath id="clip0_13559_1746">
                <rect width="192" height="128" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

VoucherRebrandingSvg.displayName = 'VoucherRebrandingSvg';
export default VoucherRebrandingSvg;
